import { io } from 'socket.io-client';
import apiPath from './constants/apiPath';

const socket = (token) =>
  io(apiPath.socketUrl, {
    auth: {
      token,
    },
    query: {
      token,
    },
  });

export default socket;
